import theme from 'config/theme'

export default {
  watch: {
    '$route' () {
      this.setColors()
    }
  },

  created () {
    this.setColors()
  },

  methods: {
    setColors: function setColors () {
      if (this.$route.name && theme.route[this.$route.name]) {
        this.$vuetify.theme = theme.route[this.$route.name].colors
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/theme.js